const _initSearch = function _initSearch() {
  $('.nav__search').on('vs.ui.navbar.search.toggle', (e) => {
    const $search = $(e.currentTarget);
    if ($search.data('mobile') === true) {
      $search.prevAll('.nav__watch__dropdown__options__language').toggleClass('hidden');
      $search.prevAll('.nav__watch__dropdown__options__btn--back').toggleClass('hidden');
    }
    $('.search').toggleClass('search--expanded');
  });

  $('.nav__watch__dropdown__options__btn--back').click((e) => {
    const $this = $(e.currentTarget);
    $this.nextAll('.search').toggleClass('search--expanded');
    setTimeout(() => {
      $this.addClass('hidden');
      $this.prevAll('.nav__watch__dropdown__options__language').removeClass('hidden');
    }, 300);
  });
};

const _initProfile = function _initProfile() {
  $('#nav-wrapper').on('click', '.nav__profile__dropdown__close-btn', (e) => {
    e.preventDefault();
    $('#nav__profile__dropdown').toggleClass('nav__profile__dropdown--expanded');
  });

  $('#nav-wrapper').on('vs.ui.navbar.profile.toggle', (e) => {
    if ($(window).width() > 544) {
      const $profile = $(e.target);
      $profile.siblings('.nav__profile-popover').toggleClass('hidden');
    } else {
      $('.sticky-wrapper').attr('style', '');
      $('#nav__profile__dropdown').toggleClass('nav__profile__dropdown--expanded');
    }
  });
};

const registerEventBindings = function registerEventBindings() {
  _initSearch();
  _initProfile();
};

const UINavbar = {
  registerEventBindings,
};

export default UINavbar;
